module.exports = require('./cartocolor');



//////////////////
// WEBPACK FOOTER
// ./~/cartocolor/index.js
// module id = 29
// module chunks = 6